import React from 'react'
import { Banner, BannerKey } from '../types'

interface ContextProps {
  warningBanners: Banner[]
  infoBanners: Banner[]
  addWarningBanners: (banners: Banner[]) => void
  addInfoBanners: (banners: Banner[]) => void
  removeBanner: (key: BannerKey) => void
  addBanner: (banner: Banner) => void
  clearBanners: () => void
}

/**
 * Context to use the same Banner array and functions in the whole app
 */
export const BannerContext = React.createContext<ContextProps>({
  warningBanners: [],
  infoBanners: [],
  addWarningBanners: () => {
    return undefined
  },
  addInfoBanners: () => {
    return undefined
  },
  removeBanner: () => {
    return undefined
  },
  addBanner: () => {
    return undefined
  },
  clearBanners: () => {
    return undefined
  },
})

export const useBannerContext = (): ContextProps => React.useContext(BannerContext)
